"use client";

import { Cards as BumbleCards } from "@bumble/ui-kit";

const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";

export default function Cards({ data }: any) {
  const cardsToRender = data?.cards?.map((card: any) => {
    return {
      title: card?.title ?? "",
      description: card?.description ?? "",
      link: card?.link?.link ?? "",
      linkText: card?.link?.text ?? "",
      image: {
        alt: card?.image?.alt ?? "Placeholder image",
        src: card?.image?.url || PLACEHOLDER_IMAGE,
      },
      type: "2-up",
    };
  });

  return (
    <BumbleCards
      cards={cardsToRender}
      size="mobile"
      type="2-up"
      viewMoreCta={undefined}
      ref={undefined}
      id={undefined}
      onScrollChange={undefined}
      onCardVisible={undefined}
    />
  );
}
